import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class ForInvestors extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get name() {
    return get(this, '_nazwa.value', '');
  }

  get buttonName() {
    return get(this, '_tekst_na_przycisku.value', '');
  }

  get date() {
    return get(this, '_data.value', '');
  }

  get downloadDoc() {
    return get(this, '_dokument_do_pobrania.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ForInvestors.model.js